import {
  FormControlLabel,
  Checkbox as MuiCheckbox,
  useTheme
} from '@mui/material';
import { FieldProps, CheckboxFieldSchema } from '../types/Form';
import { FieldWrapper } from './FieldWrapper';

export const CheckboxCheckedIcon = () => {
  const {
    palette: { primary }
  } = useTheme();
  return (
    <svg
      data-testid="checked-icon"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.78" y="0.78" width="23.44" height="23.44" rx="5.47" />
      <rect
        x="0.78"
        y="0.78"
        width="23.44"
        height="23.44"
        rx="5.47"
        stroke={primary.main}
        strokeWidth="1.56"
      />
      <path
        d="M18.75 7.81L10.16 16.41L6.25 12.5"
        stroke={primary.main}
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckboxIcon = () => {
  const {
    palette: { customGrey }
  } = useTheme();
  return (
    <svg
      data-testid="icon"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.78"
        y="0.78"
        width="23.44"
        height="23.44"
        rx="5.47"
        fill="white"
      />
      <rect
        x="0.78"
        y="0.78"
        width="23.44"
        height="23.44"
        rx="5.47"
        stroke={customGrey.dark}
        strokeWidth="1.56"
      />
    </svg>
  );
};

export const Checkbox: React.FC<FieldProps<CheckboxFieldSchema>> = ({
  name,
  value,
  field,
  errorMessage,
  onChange
}) => {
  const {
    label,
    subLabel,
    containerSx,
    checkboxLabel,
    defaultValue = false,
    controlSx,
    ...restField
  } = field;

  return (
    <FieldWrapper
      label={label}
      subLabel={subLabel}
      errorMessage={errorMessage}
      sx={containerSx}
    >
      <FormControlLabel
        sx={{
          border: 'none',
          color: errorMessage ? 'error.main' : undefined,
          marginLeft: 0,
          marginRight: 0,
          mt: label || subLabel || errorMessage ? '10px' : '0px',
          '& .MuiTypography-root': {
            marginLeft: '8px'
          },
          ...controlSx
        }}
        control={
          <MuiCheckbox
            data-testid={`checkbox-${name}`}
            checked={Boolean(value)}
            onChange={(e) => onChange(e.target.checked)}
            icon={<CheckboxIcon />}
            checkedIcon={<CheckboxCheckedIcon />}
            defaultValue={defaultValue}
            sx={{
              padding: 0,
              width: '25px',
              height: '25px'
            }}
            {...restField}
          />
        }
        label={checkboxLabel ?? ''}
      />
    </FieldWrapper>
  );
};
